import { Component } from '@angular/core';
import { StatusAppBusyStateComponentDef } from '@df/ui/display/busy-state/status-app-busy-state.component.def';

@Component({
    selector: 'status-app-busy-state',
    template: `
        <ng-template #defaultTpl>
            <ng-content></ng-content>
        </ng-template>
    `
})
export class StatusAppBusyStateComponent extends StatusAppBusyStateComponentDef {}
